<template>
	<div>
		<breadcrumb :routerList="[{to:'/contract-shenpi',title:'合同管理'},{title:'采购价格审批'}]"/>
		<div class="h-content">
			<div class="h-piece">
				<div class="h-formLine weekplandetail">
					<el-form :model="formInline" label-position="right" :inline="true"  class="demo-ruleForm h-formbLine">
						<el-form-item label="合同名称" class="h-elformWrap-2">
						<el-input readonly v-model="formInline.contractName"></el-input>
						</el-form-item>
					  <el-form-item label="合同类型" class="h-elformWrap-2">
						<el-input readonly v-model="formInline.contractCatecoryName"></el-input>
					  </el-form-item>
					  <el-form-item label="关联项目" class="h-elformWrap-2" v-if="!zlflag">
						<el-input readonly v-model="formInline.pid"></el-input>
					  </el-form-item>
					  <el-form-item :label="customerlabel" class="h-elformWrap-2">
						<el-input readonly v-model="formInline.customerName"></el-input>
					  </el-form-item>
					 <!-- <el-form-item label="产品大类" class="h-elformWrap-2" v-if="zlflag">
						<el-input readonly v-model="formInline.productType"></el-input>
					  </el-form-item>
					  <el-form-item label="产品型号" class="h-elformWrap-2" v-if="zlflag">
						<el-input readonly v-model="formInline.productCode"></el-input>
					  </el-form-item>
					  <el-form-item label="产品名称" class="h-elformWrap-2" v-if="zlflag">
						<el-input readonly v-model="formInline.productName"></el-input>
					  </el-form-item>
					  <el-form-item label="租赁数量" class="h-elformWrap-2" prop="rentNum" v-if="zlflag">
						<el-input readonly v-model="formInline.rentNum"></el-input>
					  </el-form-item> -->
					  <el-form-item label="租赁时间" class="h-elformWrap-2" prop="rentTime" v-if="zlflag">
						  <el-col class="yearIcon">
							  <el-input readonly v-model="formInline.rentTime">
							  </el-input>
						  </el-col>
					  </el-form-item>
					  <el-form-item label="保修时间" class="h-elformWrap-2" prop="guaranteeTime" v-if="zlflag">
						<el-col class="yearIcon">
							<el-input readonly v-model="formInline.guaranteeTime">
							</el-input>
						</el-col>
						</el-form-item>
					  <el-form-item label="LEG合同编号" class="h-elformWrap-2" v-if="formInline.contractType===1 && !cgflag">
					  	<el-input readonly v-model="formInline.contractCode"></el-input>
					  </el-form-item>
					  <el-form-item label="销售渠道" class="h-elformWrap-2" v-if="!cgflag&&!zlflag">
						<el-input readonly v-model="formInline.salechannelName"></el-input>
					  </el-form-item>
					  <el-form-item label="合同金额" class="h-elformWrap-2 h-moneyIcon" v-if="!cgflag">
						<el-input readonly v-model="formInline.contractAmount"></el-input>
					  </el-form-item>
					   <el-form-item label="合同状态" class="h-elformWrap-2" v-if="formInline.contractType===1&&!cgflag">
						<el-input readonly v-model="formInline.contractStatus"></el-input>
					  </el-form-item>
					   <el-form-item label="合同开始时间" class="h-elformWrap-2">
						<el-input readonly v-model="formInline.contractStarttime"></el-input>
					  </el-form-item>
					  <el-form-item label="合同结束时间" class="h-elformWrap-2">
						<el-input readonly v-model="formInline.contractEndtime"></el-input>
					  </el-form-item>
					    <el-form-item label="押金金额" class="h-elformWrap-2 h-moneyIcon" v-if="!cgflag">
						<el-input readonly v-model="formInline.contractCashPledge"></el-input>
					  </el-form-item>
					  <el-form-item label="付款条件" class="h-elformWrap-1" v-if="!cgflag && !zlflag && !bzflag">
					  </el-form-item>
					  <el-form-item label="物流方式" class="h-elformWrap-2" v-if="cgflag">
						<el-input readonly v-if="formInline.wuliufangshi==1" value="海尔自有物流"></el-input>
						<el-input readonly v-if="formInline.wuliufangshi==2" value="供应商直发"></el-input>
						<el-input readonly v-if="formInline.wuliufangshi==3" value="海尔自有物流和供应商直发皆可"></el-input>
					  </el-form-item>
					</el-form>
				</div>
				<div class="h-pieceInCon3 h-mrt0 h-mrl100" v-if="!cgflag&&!zlflag&&!bzflag">
					<div class="h-formLine h-mrb-38">
						<el-form :model="formInline" label-position="right" :inline="true"  class="demo-ruleForm h-formbLine">
						  <el-form-item label="现金" class="h-elformWrap-2">
							<el-col :span="10" class="h-percentageIcon">
							  <el-input readonly v-model="formInline.cashRatio"></el-input>
							</el-col>
							<el-col class="line h-txtCenter h-zIcon" :span="4"><img src="../../../assets/images/h-zhunhua-icon.png"></el-col>
							<el-col :span="10" class="h-moneyIcon2">
							  <el-input readonly v-model="formInline.cashAmount"></el-input>
							</el-col>
						  </el-form-item>
						  <el-form-item label="信贷" class="h-elformWrap-2">
							<el-col :span="10" class="h-percentageIcon">
							  <el-input readonly v-model="formInline.creditRatio"></el-input>
							</el-col>
							<el-col class="line h-txtCenter h-zIcon" :span="4"><img src="../../../assets/images/h-zhunhua-icon.png"></el-col>
							<el-col :span="10" class="h-moneyIcon2">
							  <el-input readonly v-model="formInline.creditAmount"></el-input>
							</el-col>
						  </el-form-item>
						</el-form>
					</div>
				</div>
				<div v-if="cgflag">
					<div class="h-pieceTitle2" style="margin:5px 0 16px 10px">
						<h1>采购产品信息</h1>
					</div>
					<el-form ref="form4" :model="formInline">
						 <el-table
								ref="multipleTable"
								:data="formInline.productListS"
								style="width: 100%"
								>
								<el-table-column
								type="index"
								label="#" width="40">
								</el-table-column>
								<el-table-column
								prop="productId"
								label="产品型号">
								</el-table-column>
								<el-table-column
								prop="productName"
								label="产品名称">
								</el-table-column>
								 <el-table-column
										 prop="oldUnitPrice"
										 label="原采购价格">
									 <template slot-scope="scope">
										 <div style="font-weight: bold;">{{scope.row.oldUnitPrice}}</div>
									 </template>
								 </el-table-column>
								<el-table-column
									prop="unitPrice"
									label="新采购价格">
										<template slot-scope="scope">
											<el-input v-model="scope.row.unitPrice" v-if="_user.usercode == formInline.spcode && formInline.pass==0"></el-input>
											<div style="font-weight: bold;" v-else>{{scope.row.unitPrice}}</div>
										</template>
								</el-table-column>
								<el-table-column
								prop="shuilv"
								label="发票税率">
									<template scope="scope">
										<brselect category="cgshuilv" :v="scope.row.shuilv" disabled v-model="scope.row.shuilv" />
									</template>
								</el-table-column>
							</el-table>
						</el-form>

					<div class="h-pieceTitle2" style="margin:5px 0 16px 10px">
						<h1>销售定价信息</h1>
					</div>
					<el-table
                            :span-method="objectSpanMethod"
							:data="tableData3"
							style="width: 100%"
							max-height="450"
							:border="true">
						<el-table-column
								type="index"
								width="40"
								label="#">
						</el-table-column>
                        <el-table-column
                                prop="materialid"
                                label="产品"
                                width="130">
                            <template slot-scope="scope">
                                <div>
                                    {{scope.row.materialid}}
                                </div>
                            </template>
                        </el-table-column>
						<el-table-column
								prop="leixing"
								label="定价类型"
								width="120">
							<template slot-scope="scope">
								<div>
									<div v-if="scope.row.leltypecode == 0">外销</div>
									<div v-if="scope.row.leltypecode == 1">内销</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="jibiequyu"
								label="级别/区域"
								width="170">
							<template slot-scope="scope">
								<div>
									<div v-if="scope.row.leltypecode == '0'">
										{{scope.row.type|dictname('dj_foreign_area')}}
									</div>
									<div v-if="scope.row.leltypecode == '1'">
										{{scope.row.type|dictname('customer_group')}}
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="bizhong"
								label="币种"
								min-width="100">
							<template slot-scope="scope">
								{{scope.row.currency}}  {{scope.row.currency|dictname('YLCurrency')}}
							</template>
						</el-table-column>
						<el-table-column
								prop="jiage"
								label="价格"
								width="120">
							<template slot-scope="scope">
								<div style="text-align: right;" >
									{{scope.row.value}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="sapHuilv"
								label="SAP汇率"
								width="120">
							<template slot-scope="scope">
								<div style="text-align: right;" >
									{{scope.row.sapHuilv}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="valuermb"
								label="折合人民币"
								width="120">
							<template slot-scope="scope">
								<div style="text-align: right;" >
									{{scope.row.valuermb}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="startdate"
								label="有效开始时间"
								width="180">
							<template slot-scope="scope">
								<div>
									{{scope.row.startdate}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="effectivedate"
								label="有效结束时间"
								width="180">
							<template slot-scope="scope">
								<div>
									{{scope.row.effectivedate}}
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div v-if="zlflag">
					<div class="h-pieceTitle2" style="margin:25px 0 16px 10px">
						<h1>租赁型号</h1>
					</div>
					<el-table
				        ref="multipleTable"
				        :data="formInline.zlList"
				        style="width: 100%"
				        >
				        <el-table-column
							type="index"
							width="40"
							label="#">
				        </el-table-column>
						<el-table-column
							prop="productType"
							:show-overflow-tooltip="true"
							label="产品大类">
						</el-table-column>
						<el-table-column
							prop="productCode"
							:show-overflow-tooltip="true"
							label="产品型号">
						</el-table-column>
						<el-table-column
							prop="productName"
							:show-overflow-tooltip="true"
							label="产品名称">
						</el-table-column>
						<el-table-column
							prop="rentNum"
							width="100"
							label="租赁数量">
						</el-table-column>
				    </el-table>
				</div>
				<div class="h-formLine h-mrt40 weekplandetail1">
					<el-form :model="formInline" label-position="right" :inline="true"  class="demo-ruleForm h-formbLine">
						  <el-form-item label="合同附件" class="h-elformWrap-2 h-formRbtnOut h-formRbtnOut2">
							<brupload :refid="this.contractId" reftype="合同附件"></brupload>
						  </el-form-item>
						<el-form-item label="变更附件" v-if="cgflag" class="h-elformWrap-2 h-formRbtnOut h-formRbtnOut2">
							<brupload :refid="this.contractId"
									  :uploadflag = "this.biang_uploaddelflag"
									  :delflag = "this.biang_uploaddelflag"  reftype="采购价变更附件"></brupload>
						</el-form-item>
						<el-form-item label="审批意见" class="h-elformWrap-2 " style="margin:20px" :required="true">
							<el-input v-model="formInline.shenpiyijian" placeholder="请输入"
							></el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="routerPath">返回</el-button>
				<el-button class="h-btn h-bBtn h-bgred"  v-if="this.taskstatus == '0' && _user.usercode != formInline.spcode && formInline.pass!=0 && formInline.pass!=4 " @click="updateShenpi(1)">驳回</el-button>
				<el-button class="h-btn h-bBtn h-bggreen" v-if="this.taskstatus == '0' && _user.usercode != formInline.spcode && formInline.pass!=0 && formInline.pass!=4 " @click="updateShenpi(2)">通过</el-button>
				<el-button class="el-button h-btn el-button--default" v-if="this.showinstid" @click="chakanjindu()">跟踪</el-button>
				<el-button class="h-btn h-bBtn"  v-if="this.taskstatus == '0' &&  _user.usercode == formInline.spcode && formInline.pass==0" @click="updateShenpi(3)">重新提交</el-button>
				<el-button class="h-btn h-bBtn h-bgred"  v-if="_user.usercode == formInline.spcode && formInline.pass==0" @click="deleteTask">删除待办</el-button>
			</div>
			<viewhistory :visible.sync="showhistory" v-if="showhistory" :id="showinstid"/>
		</div>
	</div>
</template>

<script>
	import ss from "../../../api/SystemService";
	import util from "../../../utils/util";
    export default {
        name:'leftMenu',
        data() {
            return {
                biang_uploaddelflag:false,
				customerlabel:"客户名称",
				cgflag:false,
				zlflag:false,
				bzflag:false,
                showinstid:null,
                showhistory:false,
				//表单
				formInline:{},
				contractId:this.$route.query.key||this.$route.query.ywid,
				//多选
				checkList:[],
				fileList:[],
                tableData3:[],
                taskstatus:0,
                spanArr: [],
				zlxh:[
					{
						productType:'NA4',
						productCode:'BF0260B04',
						productName:'DW-25W198',
						rentNum:'8'
					}
				],
				fukuanobj:[
					{
						nodeName:"",
						newflag:false,
						paymentRatio:"",
						paymentAmount:"",
						netValue:"",
						paymentDays:"",
						billPayMonty:""
					}
				],
            }
        },
        methods: {
            routerPath(){
				this.$router.back();
            },
            //查看进度
            chakanjindu(q){
                this.showhistory = true;
            },
			updateShenpi(flag) {
            	if(flag == 3){
					this.$msg.confirm("确认提交？",()=>{
						this.formInline.shenpiFlag = flag;
						this.formInline.instid = this.$route.query.instid;
						this.formInline.productListS = this.formInline.productListS;
						ss.contractService.updateShenpi(this.formInline).then(rd => {
							this.$router.push("/personal/dealCenter");
							this.$msg.msgs(rd.msg);
						})
					})
				}else{
                    if (flag == '1') {
                        if (!this.formInline.shenpiyijian) {
                            this.$msg.msge("驳回必须输入审批意见！");
                            return;
                        }
                    }
					this.$msg.confirm("确定审批吗？",()=>{
						this.formInline.shenpiFlag = flag;
						this.formInline.instid = this.$route.query.instid;
						this.formInline.productList = this.formInline.productListS;
						ss.contractService.updateShenpi(this.formInline).then(rd => {
                            this.$router.push("/personal/dealCenter");
							this.$msg.msgs(rd.msg);
						})
					})
				}
			},
            getSpanArr() {
                this.spanArr = [];
                this.tableData3.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData3[index].materialid === this.tableData3[index - 1].materialid) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if ( columnIndex == 1 ) {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
			deleteTask() {
				this.$msg.confirm("待办删除后此流程将无法继续推行，确认删除？",()=>{
					this.formInline.taskid = this.$route.query.taskid;
					ss.taskservice.deleteTask(this.formInline.taskid).then(rd => {
						this.$msg.msgs(rd.msg);
						//刷新右上角的代办个数
						this.$store.dispatch("searchTasktotal")
						//跳转回系统的代办列表
						this.$router.push({path:'/personal/dealCenter'})
					})
				})
			}
        },
		mounted() {
		    this.contractId = this.$route.query.ywid;
		    this.taskstatus = this.$route.query.taskstatus||0;
            this.showinstid = this.$route.query.instid||null;
		    console.log(this.contractId);
			ss.contractService.detailS(this.contractId).then(rd => {
				this.formInline = rd.obj;
				this.biang_uploaddelflag = this._user.usercode == this.formInline.spcode && this.formInline.pass==0
				console.log(this.formInline);
				var cpmcodes = _.join(_.map(rd.obj.productListS,"productId"),",");
                ss.chanpin.selectAllBymCodes({codes:cpmcodes}).then(rd => {
                    this.tableData3 = rd.obj;
                    this.getSpanArr();
                })

				if (this.formInline.contractCatecory == "CT-CG") {
					this.cgflag = true;
					this.customerlabel = "供应商名称";
				} else if (this.formInline.contractCatecory == "CT-ZL") {
					   rd.obj['fukuanobj'] = [];
						this.formInline = rd.obj;

						this.formInline.fukuanobj.push({nodeName:"押金",paymentRatio:rd.obj.contractCashRadio,paymentDays:rd.obj.contractCashDays,
									newflag:false,netValue:rd.obj.contractCashNetValue,paymentAmount:rd.obj.contractCashPledge});
					this.zlflag = true;
				} else if (this.formInline.contractCatecory == "CT-BZ") {
					this.bzflag = true;
				}
			});


		}
    }
</script>

<style scoped>
.texts{
	color: #2a89d6;
	font-size: 18px;
	text-decoration: underline
}
</style>
<style>
/* .h-formbLine .el-form-item__label{
	width: 18%;
} */
.yearIcon .el-input:after {
  content: '年';
  font-size: 0.18rem;
  color: #b8b6b6;
  /* font-weight: bold; */
  position: absolute;
  right: 0.15rem;
}
.weekplandetail .h-formbLine .el-form-item__label{
	width: 34%;
	text-align: right;
}
.weekplandetail .h-formbLine .el-form-item__content{
	width: 66%;
}
.weekplandetail .h-formbLine .h-elformWrap-2{
	width: 33.333%;
	padding-right: 0.5rem
}
.weekplandetail .h-formbLine .h-elformWrap-1{
	width: 100%;
	padding-right: 0.5rem
}
.weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__label{
	width: 10.4%;
}
.weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__content{
	width: 89.6%;
}
.weekplandetail2 .h-formbLine .h-elformWrap-2{
	width: 100%;
	padding-right: 0.5rem
}
.weekplandetail2 .h-formbLine .h-elformWrap-2 .el-form-item__label{
	width: 22.4%;
	vertical-align: middle;
}
.weekplandetail2 .h-formbLine .h-elformWrap-2 .el-form-item__content{
	width: 77.6%;
}
.weekplandetail1 .h-formbLine .h-elformWrap-2{
	width: 100%;
	padding-right: 0.5rem
}
.weekplandetail1 .h-formbLine .h-elformWrap-2 .el-form-item__label{
	width: 7%;
	vertical-align: middle;
}
.weekplandetail1 .h-formbLine .h-elformWrap-2 .el-form-item__content{
	width: 93%;
}
</style>
